import { NgModule } from "@angular/core";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatStepperModule } from "@angular/material/stepper";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";

import { MatDialogModule } from "@angular/material/dialog";
import { MatGridListModule } from "@angular/material/grid-list";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatButtonToggleModule } from "@angular/material/button-toggle";

@NgModule({
  imports: [
    MatNativeDateModule,
    MatDialogModule,
    MatGridListModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatCheckboxModule,
    MatToolbarModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatSidenavModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatBadgeModule,
    MatStepperModule,
    MatSidenavModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatTabsModule,
    MatSelectModule,
    MatSnackBarModule,
    MatButtonToggleModule
  ],
  exports: [
    MatNativeDateModule,
    MatDialogModule,
    MatGridListModule,
    FormsModule,
    MatMenuModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatSidenavModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatBadgeModule,
    MatStepperModule,
    MatSidenavModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatTabsModule,
    MatSelectModule,
    MatSnackBarModule,
    MatButtonToggleModule
  ],
  providers: [{ provide: MAT_DIALOG_DATA, useValue: null }]
})
export class MaterialModule {}
